module.exports = __webpack_public_path__ + "img/logout-icon.7748ebcd.svg";